<template>
  <a-config-provider :locale="locale">
    <router-view/>
    <ai-assistant />
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import AiAssistant from '@/components/aiAssistant';
export default {
  components: {
    AiAssistant,
  },
  data() {
    return {
      locale: zhCN,
    };
  },
  created(){
    dayjs.locale('zh-cn');
  }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
